import isEmpty from 'lodash.isempty';
import { MarkerOptions } from './locator.types';

const svg = (color: string) =>
  window.btoa(`
    <svg width="31" height="40" viewBox="0 0 31 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M0.992676 15C0.992676 6.75 7.74268 0 15.9927 0C24.2427 0 30.9927 6.75 30.9927 15C30.9927 18.25 29.7427 21.5 27.9927 24L15.9927 40L3.99268 24C2.24268 21.5 0.992676 18.25 0.992676 15ZM15.9927 7.5C11.7427 7.5 8.49268 10.75 8.49268 15C8.49268 19.25 11.7427 22.5 15.9927 22.5C20.2427 22.5 23.4927 19.25 23.4927 15C23.4927 10.75 20.2427 7.5 15.9927 7.5Z" fill="${color}"/>
    </svg>
`);

function gddsMarkerBuilder({
  maps,
  mode,
  categories,
  category: categoryName,
  draggable,
  lat,
  lng,
}: MarkerOptions) {
  const color = getColor(categoryName, mode, categories);
  const position = new maps.LatLng(lat, lng);
  const icon = buildGDDSIcon(maps, 40, color);

  const marker = {
    position,
    draggable,
    icon,
  };
  return new maps.Marker(marker);
}

function markerBuilderDefault({
  maps,
  category: categoryName,
  categories,
  draggable,
  lat,
  lng,
  mode,
}: MarkerOptions): google.maps.Marker {
  const iconSize = mode === 'hotel' ? 48 : 50;
  const color = getColor(categoryName, mode, categories);
  const icon = buildIcon(maps, iconSize, color);
  const position = new maps.LatLng(lat, lng);
  const marker = {
    position,
    draggable,
    icon,
  };

  return new maps.Marker(marker);
}

function getColor(
  categoryName: string,
  mode: string,
  categories: MarkerOptions['categories'],
): string {
  let color = 'green';
  if (mode === 'hotel') {
    color = 'hotel-blue';
  } else if (mode !== 'event' && !isEmpty(categoryName)) {
    const maybeCategorie = categories.find((category) => category.categoryName === categoryName);

    if (maybeCategorie) {
      color = maybeCategorie.color;
    }
  }
  return color;
}

function buildGDDSIcon(maps, iconSize: number, color: string) {
  const icon = {
    scaledSize: new maps.Size(iconSize, iconSize),
    origin: new maps.Point(0, 0),
    url: `data:image/svg+xml;base64,${svg(color)}`,
  };

  return icon;
}

function buildIcon(maps, iconSize: number, color: string) {
  const icon = {
    scaledSize: new maps.Size(iconSize, iconSize),
    origin: new maps.Point(0, 0),
    url: `/images/marker/marker-${color}.svg`,
  };

  return icon;
}

export function buildMarker({ isNord, ...props }: MarkerOptions & { isNord: boolean }) {
  if (isNord) {
    return gddsMarkerBuilder(props);
  }

  return markerBuilderDefault(props);
}
